/**
 * Timezone API Manager.
 */
export default class TimezoneApiManager {

    protected url;
    protected axios;

    /**
     * Constructor.
     *
     * @param {String} url
     */
    constructor(axios, url) {
        this.url = url
        this.axios = axios
    }

    /**
     * @returns {Promise<void>}
     */
    async get() {
        return await this.axios.get(`${this.url}`)
    }
}



// WEBPACK FOOTER //
// ./src/modules/user/api/managers/TimezoneApiManager.ts